import React, { ReactNode } from 'react'

import {
  AllTypeTabs,
  SelectModeProvider
} from '@/components/Calculators/components/CalculatorTabs'
import { CountdownsContextProvider } from '@/contexts/countdowns'
import { CouponContextProvider } from '@/contexts/coupon'
import { FlagsGroupContextProvider } from '@/contexts/flagsGroup'
import {
  TonMachinesProvider,
  TonMachinesProviderProps
} from '@/contexts/machines'
import { TonPlansProvider, TonPlansProviderProps } from '@/contexts/plans'
import { QRCodeDrawerProvider } from '@/contexts/qrcodeDrawer'
import { ReceivingOptionContextProvider } from '@/contexts/receivingOption'
import { SaleTypeContextProvider } from '@/contexts/saleType'
import { VideoPlayerProvider } from '@/contexts/videoPlayer'

type ProvidersProps = Omit<TonPlansProviderProps, 'children'> &
  Omit<TonMachinesProviderProps, 'children'>

interface DefaultLayoutProps extends ProvidersProps {
  children: ReactNode
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({
  children,
  defaultPlan,
  plansDetailsFromAPI,
  plansDetailsFromCMS,
  machinesDetailsFromAPI,
  machinesDetailsFromCMS
}) => {
  return (
    <ReceivingOptionContextProvider>
      <SaleTypeContextProvider>
        <FlagsGroupContextProvider>
          <CouponContextProvider>
            <TonPlansProvider
              defaultPlan={defaultPlan}
              plansDetailsFromAPI={plansDetailsFromAPI}
              plansDetailsFromCMS={plansDetailsFromCMS}
            >
              <TonMachinesProvider
                machinesDetailsFromAPI={machinesDetailsFromAPI}
                machinesDetailsFromCMS={machinesDetailsFromCMS}
              >
                <QRCodeDrawerProvider>
                  <VideoPlayerProvider>
                    <SelectModeProvider
                      defaultSelected={AllTypeTabs.AllMachines}
                    >
                      <CountdownsContextProvider>
                        {children}
                      </CountdownsContextProvider>
                    </SelectModeProvider>
                  </VideoPlayerProvider>
                </QRCodeDrawerProvider>
              </TonMachinesProvider>
            </TonPlansProvider>
          </CouponContextProvider>
        </FlagsGroupContextProvider>
      </SaleTypeContextProvider>
    </ReceivingOptionContextProvider>
  )
}

export default DefaultLayout
